import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ExportVideosTable from "../../Utils/ExportVideosTable";

// "My Videos" popup in the editor. Progress updates live while a video is exporting.
function MyVideoRenders(props) {
  const close_popup = () => props.close(false);

  return (
    <Dialog open={props.open} onClose={close_popup} fullWidth={true} maxWidth={"md"} style={{ zIndex: 99999 }}>
      <DialogTitle>Your Videos</DialogTitle>
      <div className="Note" style={{ color: "#555", marginLeft: "24px", fontSize: "13px" }}>
        Progress updates automatically. You can keep editing or close this window while your video exports.
      </div>
      <DialogContent>
        {props.open && (
          <ExportVideosTable apiBaseURL={props.apiBaseURL} enabled={props.open} setDeafultLoader={props.setDeafultLoader} />
        )}
      </DialogContent>
      <DialogActions>
        <button onClick={close_popup} type="button" className="btn btn-primary">
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default MyVideoRenders;
